module.exports = __webpack_public_path__ + "static/media/davLogo.34ebdaad.png";